import { apiCall, type ApiClientConfig } from "@playbookai/api-clients";
import type {
  PlatformModuleId,
  PlatformPage,
  PlatformSearchResult,
} from "@playbookai/types";

export interface PlatformSearchRequest {
  readonly query: string;
  readonly limit?: number | undefined;
  readonly modules?: readonly PlatformModuleId[] | undefined;
}

export function searchPlatform(
  config: ApiClientConfig,
  request: PlatformSearchRequest,
  signal?: AbortSignal,
): Promise<PlatformPage<PlatformSearchResult>> {
  return apiCall<PlatformPage<PlatformSearchResult>>(
    config,
    "GET",
    "/v1/platform/search",
    undefined,
    {
      q: request.query,
      limit: request.limit ?? 20,
      ...(request.modules ? { modules: request.modules } : {}),
    },
    signal,
  );
}
